import { actionTypes } from "../contants/actionTypes";

const initialState = {
    companyInfo: null,
    userCompanies: [],
    selectedCompanyId: null,
    isLoading: false,
    error: null,
    // Company View
    companyViewInfo: null,
    companyViewSelectedId: null,
    companyViewActive: false,
    // Company configuration
    configuration: {}
};

export const companyConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.companyConfigLoadStart:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case actionTypes.companyConfigLoadFinish:
            return {
                ...state,
                isLoading: false,
            };
        case actionTypes.companyConfigLoadCompanies:
            return {
                ...state,
                userCompanies: action.payload,
            };
        case actionTypes.companyConfigSetSelected:
            return {
                ...state,
                selectedCompanyId: action.payload.id_company,
                companyInfo: action.payload,
            };
        case actionTypes.companyConfigError:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        // Company View
        case actionTypes.companyConfigStartViewAs:
            return {
                ...state,
                companyViewSelectedId: action.payload.id_company,
                companyViewInfo: action.payload,
                companyViewActive: true,
            };
        case actionTypes.companyConfigEndViewAs:
            return {
                ...state,
                companyViewActive: false,
                companyViewInfo: null,
                companyViewSelectedId: null,
            };
        // Company configuration
        case actionTypes.companyConfigSetConfigurationData:
            return {
                ...state,
                configuration: action.payload,
            };
        default:
            return state;
    }
};
